import { useState, useMemo } from "react";
import { Card, Typography, Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { faChartSimple } from "@fortawesome/free-solid-svg-icons";
import ProjectChart from "./ProjectChart";
import MonthChart from "./MonthChart";
import FileDetailsModal from "./FileDetailsModal";
import AnalyticsFilters from "./AnalyticsFilters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { extractFilesList, getProjectStats, getMonthStats, } from "./file-utils";

const { Text } = Typography;

export function FileAnalyticsCharts({ data }) {
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [modalFiles, setModalFiles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filterProject, setFilterProject] = useState("all");
    const [filterRegistroStatus, setFilterRegistroStatus] = useState("all");
    const allFiles = useMemo(() => extractFilesList(data), [data]);
    const filteredFiles = useMemo(() => {
        return allFiles.filter((file) => {
            const projectMatch =
                filterProject === "all" || file.project === filterProject;
            const registroMatch =
                filterRegistroStatus === "all" || file.tipoRegistro === filterRegistroStatus;

            return projectMatch && registroMatch;
        });
    }, [allFiles, filterProject, filterRegistroStatus]);
    const projectStats = useMemo(
        () => getProjectStats(filteredFiles),
        [filteredFiles]
    );
    const monthStats = useMemo(() => {
        if (!selectedProject) return [];
        return getMonthStats(filteredFiles, selectedProject);
    }, [filteredFiles, selectedProject]);
    const uniqueProjects = useMemo(
        () => Array.from(new Set(allFiles.map((f) => f.project))),
        [allFiles]
    );
    const handleProjectClick = (projectName) => {
        setSelectedProject(projectName);
        setSelectedMonth(null);
    };

    const handleMonthClick = (monthName) => {
        if (!selectedProject) return;

        const files = filteredFiles.filter(
            (f) => f.project === selectedProject && f.month === monthName
        );

        setModalFiles(files);
        setSelectedMonth(monthName);
        setIsModalOpen(true);
    };

    const handleBackToProjects = () => {
        setSelectedProject(null);
        setSelectedMonth(null);
    };
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <AnalyticsFilters
                projects={uniqueProjects}
                selectedProject={filterProject}
                onProjectChange={setFilterProject}
                selectedRegistroFilter={filterRegistroStatus}
                onRegistroFilterChange={setFilterRegistroStatus}
            />
            {!selectedProject ? (
                <Card
                    style={{
                        borderRadius: 8,
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#042956",
                            color: "#fff",
                            padding: "16px",
                            borderTopLeftRadius: 5,
                            borderTopRightRadius: 5,
                            marginBottom: 16,
                        }}
                    >
                        <div style={{ fontSize: 18, fontWeight: "bold" }}>
                            <FontAwesomeIcon icon={faChartSimple} style={{ fontSize: 20, }} /> Análisis por Proyecto
                        </div>

                        <Text style={{ color: "#fff", opacity: 0.85 }}>
                            Haz clic en un proyecto para ver el desglose por mes.
                        </Text>
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <ProjectChart data={projectStats} onProjectClick={handleProjectClick} />
                    </div>
                </Card>
            ) : (
                <Card
                    style={{
                        borderRadius: 8,
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#042956",
                            color: "#fff",
                            padding: "12px 16px",
                            borderTopLeftRadius: 5,
                            borderTopRightRadius: 5,
                            marginBottom: 16,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: 6
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <FontAwesomeIcon icon={faChartSimple} style={{ marginRight: 8 }} />
                                <span style={{ fontSize: 16, fontWeight: "bold" }}>
                                    Análisis por Mes — {selectedProject}
                                </span>
                            </div>
                            <Button
                                type="default"
                                icon={<LeftOutlined />}
                                onClick={handleBackToProjects}
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#042956",
                                    border: "none",
                                    fontWeight: 600
                                }}
                            >
                                Volver
                            </Button>
                        </div>
                        <Text style={{ color: "#fff", opacity: 0.85 }}>
                            Haz clic en un mes para ver los archivos detallados.
                        </Text>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <MonthChart data={monthStats} onMonthClick={handleMonthClick} />
                    </div>
                </Card>
            )}
            <FileDetailsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                files={modalFiles}
                project={selectedProject || ""}
                month={selectedMonth || ""}
            />
        </div>
    );
}
